import React, { Children, Fragment } from 'react'
import * as ReactDOM from 'react-dom'
let popoverInstance: any[] = []

interface IPopoverProps {
  placement?: string
  content?: string
  target: any
}

export default {
  open<P>(
    customerProps?: IPopoverProps,
    component?: React.ReactElement<P>
  ): Promise<any> {
    let defaultPopoverProps = {
      content: '',
      width: 720,
      placement: 'bottom',
      style: {
        height: '100%',
        overflow: 'auto',
        paddingBottom: 53,
        backgroudColor: '#000'
      }
    }
    let targetRect = customerProps.target.getBoundingClientRect()
    let left = targetRect.left
    let top = targetRect.top + targetRect.height + 10

    let stop = (e: any) => {
      e.nativeEvent.stopImmediatePropagation()
      e.stopPropagation()
    }
    document.onclick = () => {
      this.close()
      document.onclick = null
    }

    return new Promise(() => {
      let div = document.createElement('div')
      div.classList.add('app-popover')
      if (document.querySelector('.app-popover')) return
      document.body.appendChild(div)

      let showContent = () => {
        return (
          <span
            style={{
              display: 'inline-block',
              padding: '12px 10px',
              border: '1px solid rgba(0,0,0,.1)',
              boxShadow: '1px 1px 5px rgba(0,0,0,.5)',
              borderRadius: '7px',
              backgroundColor: 'rgba(255,255,255,.8)'
            }}
          >
            {customerProps.content}
          </span>
        )
      }

      let zIndex = 3

      let popover = (
        <div
          className="popover"
          {...defaultPopoverProps}
          style={{ position: 'absolute', left, top, zIndex }}
          onClick={e => stop(e)}
        >
          {(customerProps.content && showContent()) || component || ''}
        </div>
      )

      ReactDOM.render(popover, div)
      popoverInstance.push(div)
    })
  },
  close() {
    requestAnimationFrame(() => {
      let div = popoverInstance.pop()
      const unmountResult = ReactDOM.unmountComponentAtNode(div)
      // console.log(unmountResult)
      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div)
      }
    })
    document.onclick = null
  }
}



// WEBPACK FOOTER //
// ./src/components/AppPopover/index.tsx